<template>

  <div id="dialogParent" class="dialog-parent">
    <div class="vo-scrim" :class="{active: dialogComponent, disabled: lockout.on}" @click="routeRemoveQueries(['dialog', 'dialogAction', 'dialogItem'])"></div>

    <transition name="grow">
      <div v-if="!!dialogComponent" class="center-parent">
        <div class="dialog-wrapper">
          <div class="dialog-header">
            <div class="header-title">{{ title }}</div>
            <v-btn :disabled="lockout.on" small class="close" fab flat @click="routeRemoveQueries(['dialog', 'dialogAction', 'dialogItem'])">
              <v-icon medium>mdi-close</v-icon>
            </v-btn>
          </div>
          <component class="component" @title="setTitle" ref="dialogCmp" :lockout="lockout" :is="'vo-' + dialogComponent"></component>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>

  export default {
    data () {
      return {
        title: '',
        lockout: {
          on: false
        }
      }
    },
    props: {
      dialogComponent: {

      },
    },
    methods: {
      setTitle (e) {
        this.title = e;
      }
    }
  }

</script>

<style lang="scss">

  @import '../css/global.scss';
  @import '../css/transitions.scss';

  #dialogParent {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;

    .center-parent {
      max-width: 696px;
      width: calc(100% - 32px);
      margin: 0 auto;
      pointer-events: none;
      display: flex;
      flex-direction: column;

      .dialog-wrapper {
        pointer-events: auto;

        .dialog-header {
          position: relative;
          display: flex;
          width: 100%;
          height: 50px;
          background: $primary;
  
          .header-title {
            position: absolute;
            left: 16px;
            height: 50px;
            line-height: 50px;
            color: $white;
  
            @include fontPrimary500();
            @include title();
            font-size: 16px;
          }
  
          .close {
            position: absolute;
            right: 0;
            top: 0;
            color: $white;
          }
        } // .header

        .title-area {
          @include fontPrimary500();
          @include title();

          padding: 0 0 8px;
          border-bottom: $borderBlack12;
        }

        .section {
          padding: 16px;
          box-sizing: border-box;

          .subtitle {
            @include fontPrimary500();
            @include title();
            font-size: 12px;
            margin: 16px 0 0;
          }

        }

        .dialog-content {
          position: relative;
          background: $white;
          flex-grow: 1;
          @include scrollable();
          max-height: 600px;
  
          .context {
            @include fontPrimary400();
            font-size: 12px;
            line-height: 16px;
            color: rgba(0, 0, 0, 0.54);
            margin-bottom: 24px;
            padding: 16px;
          }
        }
        
        .dialog-footer {
          position: relative;
          background: $white;
          height: 50px;
          border-top: $borderBlack12;
          text-align: right;

          .button {
            display: inline-block;
          }
        }
      
      } // .dialog-wrapper

    } // .center-parent

    @media screen and (max-height: 780px), screen and (max-width: 700px) {


      .center-parent {          
        position: absolute;
        top: 0;
        bottom: 0;
        display: block;

        .dialog-wrapper {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;

          .component {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 8px;
            top: 58px;
          }

          .dialog-header {
            position: absolute;
            width: 100%;
            height: 50px;
            background: $primary;
            top: 8px;
            left: 0;
            right: 0;
          }
  
          .dialog-content {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 50px;
            top: 0;
            max-height: none;
          }
          
          .dialog-footer {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 50px;
          }
        }
      }
    }

    @media screen and (max-width: 700px) {


      .center-parent {          
        left: 0;
        right: 0; 
        width: calc(100% - 16px); 
      }
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/DialogParent.vue